import React, { useState, useEffect } from "react";

export default function AccessibilityMenu() {
  const [highContrast, setHighContrast] = useState(false);
  const [largeText, setLargeText] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("high-contrast", highContrast);
    document.body.classList.toggle("large-text", largeText);
    document.body.classList.toggle("reduced-motion", reducedMotion);
  }, [highContrast, largeText, reducedMotion]);

  return (
    <div className="fixed bottom-20 right-4 bg-white border rounded-2xl shadow-xl p-4 w-64 z-50 text-gray-800">
      <h3 className="text-lg font-semibold mb-3">Accessibility</h3>
      <div className="space-y-2">
        <label className="flex justify-between items-center cursor-pointer">
          <span>High Contrast</span>
          <input
            type="checkbox"
            checked={highContrast}
            onChange={() => setHighContrast(!highContrast)}
            className="accent-turquoise-500"
          />
        </label>
        <label className="flex justify-between items-center cursor-pointer">
          <span>Larger Text</span>
          <input
            type="checkbox"
            checked={largeText}
            onChange={() => setLargeText(!largeText)}
            className="accent-turquoise-500"
          />
        </label>
        <label className="flex justify-between items-center cursor-pointer">
          <span>Reduced Motion</span>
          <input
            type="checkbox"
            checked={reducedMotion}
            onChange={() => setReducedMotion(!reducedMotion)}
            className="accent-turquoise-500"
          />
        </label>
      </div>
    </div>
  );
}
